import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute, ChangePasswordOnlyRoute, PublicLoginRoute, AdminOnlyOutlet, ScannerRoleRoute } from './components/ProtectedRoute';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Bookings from './pages/Bookings';
import Locations from './pages/Locations';
import Tickets from './pages/Tickets';
import Categories from './pages/Categories';
import AddOns from './pages/AddOns';
import PromoCodes from './pages/PromoCodes';
import PaymentLogs from './pages/PaymentLogs';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import Scanner from './pages/Scanner';

function HomeIndex() {
  return <Dashboard />;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicLoginRoute>
                <Login />
              </PublicLoginRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <ChangePasswordOnlyRoute>
                <ChangePassword />
              </ChangePasswordOnlyRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route
              path="scanner"
              element={
                <ScannerRoleRoute>
                  <Scanner />
                </ScannerRoleRoute>
              }
            />
            <Route element={<AdminOnlyOutlet />}>
              <Route index element={<HomeIndex />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="locations" element={<Locations />} />
              <Route path="tickets" element={<Tickets />} />
              <Route path="categories" element={<Categories />} />
              <Route path="addons" element={<AddOns />} />
              <Route path="promocodes" element={<PromoCodes />} />
              <Route path="payment-logs" element={<PaymentLogs />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
